<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5L3.76471 11H12.2353L14 5L10.8235 7.33333L8 4L5.17647 7.33333L2 5Z"
      fill="white"
    />
    <path
      d="M3.76471 13H12.2353M3.76471 11L2 5L5.17647 7.33333L8 4L10.8235 7.33333L14 5L12.2353 11H3.76471Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<style scoped>
svg {
  flex-shrink: 0;
}
</style>
